import { useSetting } from '@tencent/setting-vue-webpack-plugin';
var setting = useSetting('颜色主题', {
  颜色: {
    type: 'object',
    properties: {
      'primary-color': {
        type: 'color',
        default: '#ff4e5a'
      },
      'secondary-color': {
        type: 'color',
        default: '#c2731f'
      },
      'secondary-color-70': {
        type: 'color',
        default: '#BB7B18'
      },
      'tertiary-color': {
        type: 'color',
        default: '#a4511a'
      },
      'other-color': {
        type: 'color',
        default: '#5c8ad8'
      }
    }
  }
});
export default setting;

for (var key in setting.颜色) {
  if (key.indexOf('color') >= 0) {
    document.body.style.setProperty("--".concat(key), setting.颜色[key]);
  }
}